module.exports = __webpack_public_path__ + "img/upload-folder-blue.4b846a34.svg";